import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { CardView } from 'src/Component/Card'
import { ReactComponent as ChevronIcon } from 'images/chevron.svg'
import { Title1 } from 'src/Styles/text-styles'
import { useTheme } from 'src/Styles/theme'

const Title = styled(Title1)`
  font-weight: 600;
  @media (min-width: 480px) {
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 4px;
    line-height: 24px;
  }
  @media (max-width: 480px) {
    margin-right: 4px;
    margin-left: 4px;
    margin-bottom: 4px;
    line-height: 24px;
  }
  @media (min-width: 768px) {
    margin-right: 8px;
    margin-left: 8px;
    margin-bottom: 8px;
    line-height: 32px;
  }
`

const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

interface Props {
  title: string
  style?: CSSProperties
  onPress?(): void
}
const CardInfo = ({ title, style, onPress }: Props) => {
  const infoStyle = { marginRight: '8px' }

  const onCardPress = () => {
    if (onPress) {
      onPress()
    }
  }
  const { primary } = useTheme().colors

  return (
    <CardView style={style} onPress={onCardPress}>
      <Row>
        <Title>{title}</Title>
        <ChevronIcon width={16} height={16} />
      </Row>
    </CardView>
  )
}

export default CardInfo
